<template>
    <div class="col-md-3 spark-settings-tabs">
        <aside>
            <h3 class="nav-heading ">
                Home
            </h3>
            <ul class="nav flex-column mb-4 ">
              <li key='overview' class="nav-item">
                  <a class="nav-link" href="#overview" aria-controls="overview" role="tab" data-toggle="tab">
                      <div>
                          <span class="nav-icon">
                              <i class="fas fa-clipboard-list fa-lg"></i>
                          </span>Overview
                      </div>
                  </a>
              </li>
                <li class="nav-item ">
                    <a class="nav-link" href="#change-orders" aria-controls="change-orders" role="tab" data-toggle="tab">
                        <span class="nav-icon">
                          <i class="fas fa-file-signature fa-lg"></i>
                        </span>Change Orders
                    </a>
                </li>
                <li class="nav-item ">
                    <a class="nav-link" href="#selections" aria-controls="selections" role="tab" data-toggle="tab">
                        <span class="nav-icon">
                          <i class="fas fa-paint-roller fa-lg"></i>
                        </span>Material Selections
                    </a>
                </li>
            </ul>
        </aside>
    </div>
</template>

<script>
    export default {
        
        mixins: [require('../../../../../spark/resources/assets/js/mixins/tab-state')],

        created: function() {
            // Gracefully handle tab changes
            let vm = this;
            Bus.$on('sparkHashChanged', function (hash, parameters) {
                vm.currentTab = hash;

                // Required to re-register the animated tabs now visible
                vm.$nextTick(() => {
                    vm.registerTabClickHandler();
                });

                return true;
            });
            Bus.$on('set-current-project', function (project) {
                vm.currentProject = project;
            });

            //if somebody manually types it in:
            $(window).bind('hashchange', function() {
                vm.activateTabForCurrentHash(); 
            });

            this.getProjects();
        },

        mounted: function() {
            this.usePushStateForTabs('.spark-settings-tabs');
        },

        data: function() {
            return {
                currentTab: '',
                projects:[],
                filteredProjects:[],
                loadingProjects: true,
                projectFilterInput: '',
                currentProject: null
            };
        },

        computed: {
            
        },

        methods: {
            beforeLeave(el) {
                const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
                el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
                el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
                el.style.width = width
                el.style.height = height
              },

            updateCurrentProject: function(project) {
                Bus.$emit('set-current-project', project);
            },

            getProjects: function() {
               this.projects = [];
               axios.get(`/api/projects`)
                   .then(response => {
                       this.loadingProjects = false;
                       this.error = false;
                       this.projects = response.data;
                       this.filteredProjects = this.projects;
                       if (this.filteredProjects.length > 0) {
                           this.currentProject = this.projects[0];
                           this.updateCurrentProject(this.currentProject);
                       }
                   })
                   .catch(error => {
                      this.loadingProjects = false;
                      this.error = true;
                   });
           },
        }
    }
</script>
